import { Button } from 'antd';
import styled from 'styled-components';

export const ModalButtonStyled = styled(Button)`
	width: 100%;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: unset;
	}
`;

export const ButtonsContainerStyled = styled.div`
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: flex;
		flex-direction: column-reverse;
		gap: 8px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
	}
`;
